import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Faq() {
  const [openId, setOpenId] = useState(faqs[0].id);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4">
        <SectionHeading
          eyebrow="常见问题"
          title="关于最新地址与访问的疑问"
          desc="整理了大家问得最多的几个问题。如果你的情况没被覆盖，可以参照「解决方法」中的步骤逐条排查。"
          align="center"
        />

        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          {faqs.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? "" : item.id)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center gap-3 p-4 text-left md:p-5"
                >
                  <i className="ri-question-line text-lg text-primary-600"></i>
                  <span className="flex-1 font-heading text-base font-bold text-foreground-950">
                    {item.q}
                  </span>
                  <i
                    className={
                      isOpen
                        ? "ri-arrow-up-s-line text-xl text-primary-600"
                        : "ri-arrow-down-s-line text-xl text-foreground-400"
                    }
                  ></i>
                </button>
                <div className="px-4 pb-5 pl-11 md:px-5">
                  <p className="text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}